import { jsx as o } from "react/jsx-runtime";
import { c as i } from "../../../index-Cu0xwYjD.js";
import '../../../assets/List.css';const e = "_list_cyxlt_3", u = "_ul_cyxlt_17", n = "_withBullets_cyxlt_21", r = "_ol_cyxlt_46", a = "_li_cyxlt_3", l = {
  list: e,
  ul: u,
  withBullets: n,
  ol: r,
  li: a
}, y = ({
  children: t,
  showBullets: s = !0,
  className: c,
  ..._
}) => /* @__PURE__ */ o(
  "ul",
  {
    className: i(
      l.list,
      l.ul,
      {
        [l.withBullets]: s
      },
      c
    ),
    ..._,
    children: t
  }
), h = ({
  children: t,
  className: s,
  ...c
}) => /* @__PURE__ */ o("ol", { className: i(l.list, l.ol, s), ...c, children: t }), w = ({
  children: t,
  className: s,
  ...c
}) => /* @__PURE__ */ o("li", { className: i(l.li, s), ...c, children: t });
export {
  w as Li,
  h as Ol,
  y as Ul
};
